// extracted by mini-css-extract-plugin
module.exports = {"marketing__cta":"cta_marketing__cta__xWDY_","marketing__cta_blue":"cta_marketing__cta_blue__HRuzd","marketing_cta_tailicon":"cta_marketing_cta_tailicon__HxxvR"};